import { VolumeSpec } from "../../../../schema/types/volumeSpec";
import { VolumeInput, VolumeUriType } from "../../../../schema/types/workload/input";
import { v4 as uuidv4 } from "uuid";
import { getDefaultKindSelectState } from "../../../../components/antd/kindselect/KindSelect";

export function getDefaultVolumeInput(): VolumeInput {
  return {
    id: uuidv4(),
    uriType: "cpln://secret/",
    cplnSecret: getDefaultKindSelectState(),
    cplnSecretProperty: "",
    k8sSecret: "",
    volumeSet: getDefaultKindSelectState(),
    s3: "",
    gs: "",
    azureBlob: "",
    azureFs: "",
    scratch: "",
    path: "",
  };
}

export function inputToVolume(inputs: VolumeInput[]): VolumeSpec[] {
  let volumes: VolumeSpec[] = [];
  for (const vm of inputs) {
    if (!vm.path) {
      continue;
    }

    let uri = "";

    switch (vm.uriType) {
      case "cpln://secret/": {
        if (!vm.cplnSecret.value) continue;
        const property = vm.cplnSecretProperty ? `.${vm.cplnSecretProperty}` : "";
        uri = `cpln://secret/${vm.cplnSecret.value}${property}`;
        break;
      }
      case "k8s://secret/": {
        if (!vm.k8sSecret) continue;
        uri = `k8s://secret/${vm.k8sSecret}`;
        break;
      }
      case "cpln://volumeset/": {
        if (!vm.volumeSet.value) continue;
        uri = `cpln://volumeset/${vm.volumeSet.value}`;
        break;
      }
      case "s3://": {
        if (!vm.s3) continue;
        uri = `s3://${vm.s3}`;
        break;
      }
      case "gs://": {
        if (!vm.gs) continue;
        uri = `gs://${vm.gs}`;
        break;
      }
      case "azureblob://": {
        if (!vm.azureBlob) continue;
        uri = `azureblob://${vm.azureBlob}`;
        break;
      }
      case "azurefs://": {
        if (!vm.azureFs) continue;
        uri = `azurefs://${vm.azureFs}`;
        break;
      }
      case "scratch://": {
        if (!vm.scratch) continue;
        uri = `scratch://${vm.scratch}`;
        break;
      }
      default:
        continue;
    }

    volumes.push({ uri: uri, path: vm.path, recoveryPolicy: "retain" });
  }
  return volumes;
}

export function volumeToInput(volumes: VolumeSpec[]): VolumeInput[] {
  let inputs: VolumeInput[] = [];

  const prefixes: { prefix: string; type: VolumeUriType }[] = [
    { prefix: "cpln://secret/", type: "cpln://secret/" },
    { prefix: "k8s://secret/", type: "k8s://secret/" },
    { prefix: "cpln://volumeset/", type: "cpln://volumeset/" },
    { prefix: "s3://", type: "s3://" },
    { prefix: "gs://", type: "gs://" },
    { prefix: "azureblob://", type: "azureblob://" },
    { prefix: "azurefs://", type: "azurefs://" },
    { prefix: "scratch://", type: "scratch://" },
  ];

  for (const v of volumes) {
    if (!v.uri || !v.path) {
      continue;
    }

    const volumeInput = getDefaultVolumeInput();
    volumeInput.path = v.path;

    // Find matching prefix
    const matched = prefixes.find((p) => v.uri.startsWith(p.prefix));
    if (!matched) {
      continue;
    }

    volumeInput.uriType = matched.type;
    const value = v.uri.slice(matched.prefix.length);

    switch (matched.type) {
      case "cpln://secret/": {
        let secretName = value;
        let property = "";
        if (value.includes(".")) {
          const dotIndex = value.indexOf(".");
          secretName = value.slice(0, dotIndex);
          property = value.slice(dotIndex + 1);
        }
        volumeInput.cplnSecret = {
          value: secretName,
          link: `//secret/${secretName}`,
        };
        volumeInput.cplnSecretProperty = property;
        break;
      }
      case "k8s://secret/": {
        volumeInput.k8sSecret = value;
        break;
      }
      case "cpln://volumeset/": {
        volumeInput.volumeSet = {
          value: value,
          link: `//volumeset/${value}`,
        };
        break;
      }
      case "s3://": {
        volumeInput.s3 = value;
        break;
      }
      case "gs://": {
        volumeInput.gs = value;
        break;
      }
      case "azureblob://": {
        volumeInput.azureBlob = value;
        break;
      }
      case "azurefs://": {
        volumeInput.azureFs = value;
        break;
      }
      case "scratch://": {
        volumeInput.scratch = value;
        break;
      }
    }

    inputs.push(volumeInput);
  }
  return inputs;
}
